toastr.options.positionClass = "toast-bottom-right";

var grecaptcha_login = null;
var grecaptcha_register = null;

$(document).on('click', '.btn-sso', function() {

    $(this).addClass('disabled');

    let obj = {};

    let type = $(this).data('type');

    if (type) {
        obj.type = type;
    }

    let callback_url = $(this).data('callback_url');

    if (callback_url) {
        obj.callback_url = callback_url;
    }

    let referral_code = farm.getCookie('IR_REF');

    if (referral_code) {
        obj.referral_code = referral_code;
    }

    let url = APP_URL + '/sso';

    if (Object.keys(obj).length) {
        const params = Object.entries(obj).map(([key, val]) => `${key}=${encodeURIComponent(val)}`).join('&')
        url += '?' + params;
    }

    window.location.href = url;
});

window.farm = (function () {
    "use strict";

    function initDatePicker(element, options = {}) {

        if (!$(element).length) return;

        var options = $.extend({},
            $.datepicker.regional[LANG], {
                showButtonPanel: true,
                changeMonth: true,
                changeYear: true,
                dateFormat: "dd/mm/yy",
                ...options
            }
        );

        $(element).datepicker(options);
    }



    function checkRequiredInputs(LANG = 'vi') {
        try {
            const requiredInputs = document.querySelectorAll('input[required], select[required]');

            requiredInputs.forEach(function(input) {
                let message = '';

                if (input.tagName.toLowerCase() === 'input') {
                    if (input.type === 'checkbox') {
                        switch (LANG) {
                            case 'vi':
                                message = 'Vui lòng đánh dấu ô này nếu bạn muốn tiếp tục';
                                break;
                            case 'en':
                                message = 'Please check this box if you want to process';
                                break;
                            default:
                                message = 'This field is required';
                        }
                    } else {
                        switch (LANG) {
                            case 'vi':
                                message = 'Vui lòng nhập đầy đủ thông tin';
                                break;
                            case 'en':
                                message = 'Please enter required information';
                                break;
                            default:
                                message = 'This field is required';
                        }
                    }
                } else if (input.tagName.toLowerCase() === 'select') {
                    switch (LANG) {
                        case 'vi':
                            message = 'Vui lòng chọn một mục trong danh sách';
                            break;
                        case 'en':
                            message = 'Please select an item in the list';
                            break;
                        default:
                            message = 'This field is required';
                    }
                }


                input.setAttribute('oninvalid', `this.setCustomValidity('${message}')`);
                input.setAttribute('oninput', "this.setCustomValidity('')");
            });
        } catch (error) {
           console.log(error)
        }

    }
    function checkRefCode() {
        var url_string = window.location.href;
        var url = new URL(url_string);
        var ref = url.searchParams.get("ref");
        if (ref) setCookie("IR_REF", ref, 30);

        if (document.referrer) {
            if (!document.referrer.includes(window.location.hostname)) {
                setCookie("IR_REF_SOURCE", document.referrer, 30);
            } else if (ref) {
                setCookie("IR_REF_SOURCE", ref, 30);
            }
        }

        var ref_source = url.searchParams.get("ref_source");
        if (ref_source) setCookie("IR_REF_SOURCE", ref_source, 30);

    }

    function copyToClipboard(text) {
        var $temp = $("<input>");
        $("body").append($temp);
        $temp.val(text).select();
        $temp.focus();
        document.execCommand("copy");
        $temp.remove();
    }

    function validInput() {
        var delay = 0;
        var offset = 150;

        document.addEventListener(
            "invalid",
            function (e) {
                $(e.target).addClass("invalid");
                $("html, body").animate(
                    { scrollTop: $($(".invalid")[0]).offset().top - offset },
                    delay
                );
            },
            true
        );

        document.addEventListener(
            "change",
            function (e) {
                $(e.target).removeClass("invalid");
            },
            true
        );
    }

    function formatPhone(phone) {
        phone = phone.replaceAll(/\s/g, "").replace(/[^0-9]/gi, "");
        if (phone.charAt(0) != "0") {
            phone = "0" + phone;
        }
        return phone;
    }

    function formatMoney(num) {
        if (num) num = num.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
        return num + "đ";
    }

    function formatNumber(num) {
        if (num)
            num = num.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
        return num;
    }

    function getNumber(text) {
        return  text.replace(/^\D+/g, '');
    }

    function isEmail(email) {
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
    }

    function reloadPage(url = null, timeout = 1500) {
        setTimeout(function () {
            if (url) return (window.location.href = url);
            window.location.reload();
        }, timeout);
    }

    function initValueSelect() {
        $("select[data-value]").each(function () {
            let is_change = 0;
            var value = $(this).data("value");
            if (!value) return;

            if ($(this).attr("name") == "province") {
                value = $(this).find('option:contains("' + value + '")').attr("value");
                is_change = 1;
            }

            $(this).val(value);

            if (is_change) $(this).change();

        });
    }

    function checkUserHotline() {
        if (
            $("#modal-change-hotline").length &&
            $("input[name=is_empty_lines]").length
        ) {
            $("#modal-change-hotline").modal("show");
        }
    }

    function isValidDate(year, month, day) {
        month = month - 1;
        var d = new Date(year, month, day);
        if (
            d.getFullYear() == year &&
            d.getMonth() == month &&
            d.getDate() == day
        ) {
            return true;
        }
        return false;
    }

    function isDate(str) {
      return 1;
        let timestamp = Date.parse(str);
        if (isNaN(timestamp)) return 0;
        return 1;
    }

    function getAge(date_str, special_date = null) {
        var today = special_date && isDate(special_date) ? new Date(special_date) : new Date();
        var dob = new Date(date_str);
        var age = today.getFullYear() - dob.getFullYear();

        var m = today.getMonth() - dob.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) {
            age--;
        }

        return age;
    }



    function setCookie(name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            expires = "; expires=" + date.toUTCString();
        }

        var domain = window.location.hostname;
        if (domain.includes("irace.vn")) domain = "irace.vn";

        document.cookie =
            name +
            "=" +
            (value || "") +
            expires +
            ";domain=." +
            domain +
            ";path=/";
    }

    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(";");
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == " ") c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0)
                return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    function eraseCookie(name) {
        document.cookie = name + "=; Max-Age=-99999999;";
    }

    function checkValidBrowserApplePay() {
      if ($('.form-check-apple-pay').length && !window.ApplePaySession) {
        $('.form-check-apple-pay').addClass('disabled');
        $('.form-check-apple-pay label').addClass('disabled');
        $('.form-check-apple-pay input').prop('disabled', true);
      }
    }

    function addParamToCurrentUrl(key, value) {
      var url = new URL(location.href);
      url.searchParams.set(key, value);
      return url.href;
    }

    function formatDate(date) {
      var date = new Date(date);
      var d = date.getDate() > 9 ? date.getDate() : '0' + date.getDate();
      var m = date.getMonth() > 8 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1);
      var y = date.getFullYear();
      return d + '/' + m + '/' + y;
    }

    function formatDateTime(date) {
        var date = new Date(date);
        var d = date.getDate() > 9 ? date.getDate() : '0' + date.getDate();
        var m = date.getMonth() > 8 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1);
        var y = date.getFullYear();
        var min = date.getUTCMinutes();
        if (min < 10) min = '0' + min;
        var s = date.getUTCSeconds();
        if (s < 10) s = '0' + s;
        return d + '/' + m + '/' + y + ' ' + min + ':' + s;
    }

    return {
        isEmail: isEmail,
        getAge: getAge,
        isDate: isDate,
        formatMoney: formatMoney,
        formatNumber: formatNumber,
        getNumber: getNumber,
        reloadPage: reloadPage,
        initValueSelect: initValueSelect,
        formatPhone: formatPhone,
        checkUserHotline: checkUserHotline,
        copyToClipboard: copyToClipboard,
        isValidDate: isValidDate,
        validInput: validInput,
        setCookie: setCookie,
        getCookie: getCookie,
        eraseCookie: eraseCookie,
        checkRefCode: checkRefCode,
        initDatePicker: initDatePicker,
        checkValidBrowserApplePay: checkValidBrowserApplePay,
        addParamToCurrentUrl: addParamToCurrentUrl,
        formatDate: formatDate,
        formatDateTime: formatDateTime,
        checkRequiredInputs: checkRequiredInputs
    };
})();

farm.checkRequiredInputs(LANG);
farm.validInput();
farm.checkRefCode();
farm.checkValidBrowserApplePay();

$("#modal-change-password form").submit(function (e) {
    e.preventDefault();
    var data = $(this).serialize();
    $.post("/admin/api/staffs/change-password", data, function (res) {
        Swal.fire("Thành công", "Cập nhật thành công", "success");
        farm.reloadPage();
    }).fail(function (jqXHR) {
        Swal.fire("Lỗi", jqXHR.responseJSON.message, "error");
    });
});

if ($(window).width() > 768 && $(".event-menu").length) {

    var menu_offset_top = 0;
    var menu_height = $(".event-menu").outerHeight(true);;
    var sidebar_height = 0;
    var description_height = 0;
    var window_height = window.innerHeight;
    var description_offset_top = 0;
    $(window).on('load', function() {
        menu_offset_top = $(".event-menu").offset().top;
        $(".sidebar-right").css("width", $(".sidebar-right").width());
        sidebar_height = $('.sidebar-right').outerHeight();
        description_height = $('.event-description').height();
        description_offset_top = $('.event-description').offset().top;
        var bottom_footer = description_offset_top + description_height - menu_height;

        $(window).scroll(function () {
            var scroll_top = $(window).scrollTop();

            if (scroll_top > menu_offset_top && scroll_top + sidebar_height < bottom_footer) {
                $(".event-menu").addClass("fixed");
                $(".event-description").css("padding-top", menu_height);
                $(".sidebar-right").addClass("fixed").removeClass('bottom')
                $(".sidebar-right").css("top", menu_height);
            } else if (scroll_top + window_height >=  bottom_footer) {
                $(".event-menu").removeClass("fixed");
                $(".event-description").css("padding-top", 0);
                $(".sidebar-right").removeClass("fixed").addClass('bottom');
                $(".sidebar-right").css("top", 'initial');
            } else {
                $(".event-menu").removeClass("fixed");
                $(".event-description").css("padding-top", 0);
                $(".sidebar-right").removeClass("fixed bottom");
                $(".sidebar-right").css("top", 0);
            }
        });

    });
}


$("select[name=province]").change(function () {
    if ($(this).hasClass('provinces')) return;
    
    var id = $(this).val();
    if (!id) return;

    if ($('#personal_information_district.d-none').length) return;

    var data = {
        province_id: id,
        _token: $("input[name=_token]").val(),
    };

    var url = APP_URL + "/api/region/districts";

    var init_value = null;
    var data_value = $("select[name=district]").data("value");
    $(this).removeAttr("data-value");
    if (data_value) {
      $("select[name=district]").removeAttr("data-value");
    }

    $.post(url, data, function (res) {
        var options = "";

        $.each(res.data, function (index, elem) {
            if (data_value && data_value == elem.name) init_value = elem.id;
            options += '<option value="' + elem.id + '">' + elem.name + "</option>";
        });

        $("select[name=district]").html(options);
        if (init_value) $("select[name=district]").val(init_value);
        $("select[name=district]").change();

        $("select[name=district]").removeClass("invalid");
    });
});

$("select[name=district]").change(function () {
    var id = $(this).val();

    var data = {
        district_id: id,
        _token: $("input[name=_token]").val(),
    };

    var url = APP_URL + "/api/region/wards";

    var init_value = null;
    var data_value = $("select[name=ward]").data("value");
    if (data_value) $("select[name=ward]").removeAttr("data-value");

    $.post(url, data, function (res) {
        var options = "";

        $.each(res.data, function (index, elem) {
            if (data_value && data_value == elem.name) init_value = elem.id;
            options += '<option value="' + elem.id + '">' + elem.name + "</option>";
        });

        $("select[name=ward]").html(options);
        if (init_value) $("select[name=ward]").val(init_value);
    });

    if (init_value) $("select[name=ward]").val(init_value);

    $("select[name=ward]").removeClass("invalid");
});

$(".provinces").change(function () {
    var id = $(this).val();

    var data = {
        _token: $("input[name=_token]").val(),
    };

    var url = APP_URL + "/api/provinces/" + id + "/wards";

    var data_value = $(".item-ward").data("value");
    if (data_value) $(".item-ward").removeAttr("data-value");

    $.post(url, data, function (res) {
        var options = "";
        $.each(res.data, function (index, elem) {
            const is_selected = data_value && data_value == elem.name;
            options += '<option value="' + elem.name + '" ' + (is_selected ? 'selected' : '') + '>' + elem.name + "</option>";
        });

        $(".item-ward").html(options);
    });

    $("select[name=ward]").removeClass("invalid");
});

$(".form-login").submit(function (e) {
    e.preventDefault();
    var data = $(this).serialize();
});

$("select[name=nationality]").change(function () {
    if ($(this).val() !== "Việt Nam") {
        $(".wrap-item-address").each(function(index, item) {
            $(this).find('select').prop("required", false);
            $(this).find('select').val('');

            if ($(this).hasClass('d-none-field')) {
                $(this).addClass('foreigner');
            } else {
                $(this).addClass("d-none foreigner");
            }
        });
    } else {
        $(".wrap-item-address").each(function(index, item) {
            if ($(this).hasClass('d-none-field')) return;
            $(this).removeClass("d-none");
            $(this).find('select').prop("required", true);
        });
    }
});

$(window).on("load", function () {
    if ($("select[name=nationality]").length) {
        setTimeout(function() {
            $("select[name=nationality]").change();
        }, 500);
    }
});

$("#modal-repayment form").submit(function (e) {
    e.preventDefault();
    var data = $(this).serialize();
    var url = APP_URL + "/api/checkout/repayment";
    $.LoadingOverlay("show");
    $.post(url, data, function (res) {
        if (res.data.payment_method != "TRANSFER" && !res.data.redirect_url) {
            return toastr.error("Có lỗi xảy ra, xin vui lòng thử lại");
        }
        window.location.href = res.data.redirect_url;
    }).fail(function (xhr, status, error) {
        toastr.error(xhr.responseJSON.message);
    }).always(function () {
        $.LoadingOverlay("hide");
    });
});

$("#modal-payment form").submit(function (e) {
    e.preventDefault();
    var data = $(this).serializeArray();
    var url = $(this).find('input[name=payment_url]').val();
    $.LoadingOverlay("show");
    $.post(url, data, function (res) {
        window.location.href = res.data.payment_url;
    }).fail(function (xhr, status, error) {
        toastr.error(xhr.responseJSON.message);
    }).always(function () {
        $.LoadingOverlay("hide");
    });
});

$("#check-term").change(checkEnableBtnPayment);
$("#check-term-btc").change(checkEnableBtnPayment);

function checkEnableBtnPayment() {
    var is_active = 1;

    if (!$("#check-term").is(":checked")) is_active = 0;

    if ($("#check-term-btc").length) {
        if (!$("#check-term-btc").is(":checked")) is_active = 0;
    }

    if (is_active) {
        $(".btn-payment").removeClass("disabled");
    } else {
        $(".btn-payment").addClass("disabled");
    }
}

$("input[name=show_password]").change(function (e) {
    if ($(this).is(":checked")) {
        $(this).closest("form").find("input[name=password]").attr("type", "text");
        $(this).closest("form").find("input[name=confirm_password]").attr("type", "text");
    } else {
        $(this).closest("form").find("input[name=password]").attr("type", "password");
        $(this).closest("form").find("input[name=confirm_password]").attr("type", "password");
    }
});

$("html").click(function (event) {
    if ($(event.target).closest("#topnav-menu-content").length === 0) {
        $("#topnav-menu-content").removeClass("show");
        $("#topnav-menu-content").find(".nav-item.dropdown.active").find(".show").removeClass("show");
        $("#topnav-menu-content").find(".nav-item.dropdown.active").removeClass("active");
    }
});

$("#topnav-menu-content .navbar-nav").on(
    "click",
    "li.nav-item.dropdown",
    function (e) {
        if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            $(this).find(".dropdown-menu").first().removeClass("show");
        } else {
            $(this).siblings(".active").find(".show").removeClass("show");
            $(this).siblings(".active").removeClass("active");
            $(this).addClass("active");
            $(this).find(".dropdown-menu").first().addClass("show");
        }
    }
);

$("#topnav-menu-content .navbar-nav").on(
    "click",
    ".dropdown-child",
    function (e) {
        e.preventDefault();
        e.stopPropagation();
        if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            $(this).find(".dropdown-menu").first().removeClass("show");
        } else {
            $(this).addClass("active");
            $(this).find(".dropdown-menu").first().addClass("show");
        }
    }
);

$("#topnav-menu-content .navbar-nav").on(
    "click",
    ".dropdown-child .dropdown-menu a",
    function (e) {
        e.preventDefault();
        e.stopPropagation();
        window.location.href = $(this).attr("href");
    }
);

$(".container-filter-event .content-action .list-action span").click(
    function () {
        $(
            ".container-filter-event .content-action .list-action span"
        ).removeClass("active");

        $(this).addClass("active");
    }
);

if ($('.profile').length) {
    $('.profile .wrapper-sidebar a').each(function() {
        const dataName = $(this).data('name');
        if (dataName && window.location.pathname.includes(dataName)) {
            $('.profile .wrapper-sidebar a.active').removeClass("active");
            $(this).addClass('active');
        }
    });
}


// Toggle password

$(document).on('click', '.mdi-eye-off-outline', function() {
    $(this).addClass('mdi-eye-outline').removeClass('mdi-eye-off-outline');
    $(this).closest('.input-group').find('input').attr('type', 'text');
});

$(document).on('click', '.mdi-eye-outline', function() {
    $(this).addClass('mdi-eye-off-outline').removeClass('mdi-eye-outline');
    $(this).closest('.input-group').find('input').attr('type', 'password');
});


$(document).on('click', '[data-copy]', function () {
    try {
        var text = $(this).data('copy');
        farm.copyToClipboard(text);
        if (typeof toastr != 'undefined' && typeof COPIED != 'undefined') {
            toastr.success(COPIED);
        }
    } catch (error) {
        console.log(error)
     }
});

$('.btn-add-to-google-wallet').click(function() {
    const order_id = $(this).data('order_id');
    const athlete_id = $(this).data('athlete_id') || null;
    const url = APP_URL + '/api/add-to-google-wallet';

    const data = {
        order_id: order_id,
        athlete_id: athlete_id,
        _token: $("meta[name=csrf-token]").attr('content')
    }

    $.LoadingOverlay("show");

    $.post(url, data, function (res) {
        window.open(res.data, '_blank');
    }).fail(function (xhr, status, error) {
        toastr.error(xhr.responseJSON.message);
    }).always(function () {
        $.LoadingOverlay("hide");
    });
});